import { createAction, props } from '@ngrx/store';

export const resetToInitialState = createAction('[SETTINGS] Reset to Initial state');

export const setValidation = createAction('[SETTINGS] Set Validation', props<{ isValid: boolean }>());
